import { InternalNetworkTunnelContract } from '@terra/shared-contracts-internal-network-tunnel';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const internalNetworkTunnelClient = createTerraOrpcClient({
  contract: InternalNetworkTunnelContract,
});
